import requests from '@/utils/request.js'
import { callDynamicAPI } from '@/utils/dynamicApi.js'

// 使用动态API配置替代硬编码URL
export const getIndustryDataAPI = () => callDynamicAPI('common', 'industry')
export const getCaseTypeDataAPI = () => callDynamicAPI('common', 'caseType')
export const getGroupDataAPI = () => callDynamicAPI('common', 'group')
export const getDepartmentDataAPI = () => callDynamicAPI('common', 'department')
export const getPositionListDataAPI = () => callDynamicAPI('common', 'positionList')
export const getJobListDataAPI = (pid) => callDynamicAPI('common', 'jobList', { pid })
export const getCaseCaseSourceAPI = (data) => callDynamicAPI('common', 'caseSource', data)
export const getpersonlist = (data) => callDynamicAPI('common', 'personList', data)
export const getweituoListAPI = (data) => callDynamicAPI('common', 'clientList', data)


